import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

export const SingleTransactionResponseSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  created_by: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  event_type: z.string().optional().nullable(),
  amount: z.coerce.number().optional().nullable(),
  note: z.string().optional().nullable(),
  order_id: z.string().optional().nullable(),
  purchase_id: z.string().optional().nullable(),
  expense_id: z.string().optional().nullable(),
  sales_return_id: z.string().optional().nullable(),
});

export const TransactionResponseSchema = z.object({
  data: z.array(SingleTransactionResponseSchema),
  pagination: PaginationResponseSchema,
});

export type SingleTransactionResponseType = z.infer<
  typeof SingleTransactionResponseSchema
>;
export type TransactionResponseType = z.infer<typeof TransactionResponseSchema>;
